import { __exports as c } from "./index765.mjs";
import { d as E } from "./index795.mjs";
import { i as l } from "./index812.mjs";
import { v as D } from "./index827.mjs";
import { a as d } from "./index828.mjs";
import { t as _ } from "./index810.mjs";
var g = E, w = l, I = D, n = d, y = _, R = TypeError, p = Object.defineProperty, T = Object.getOwnPropertyDescriptor, f = "enumerable", i = "configurable", v = "writable";
c.f = g ? I ? function(o, e, r) {
  if (n(o), e = y(e), n(r), typeof o == "function" && e === "prototype" && "value" in r && v in r && !r[v]) {
    var a = T(o, e);
    a && a[v] && (o[e] = r.value, r = {
      configurable: i in r ? r[i] : a[i],
      enumerable: f in r ? r[f] : a[f],
      writable: !1
    });
  }
  return p(o, e, r);
} : p : function(o, e, r) {
  if (n(o), e = y(e), n(r), w)
    try {
      return p(o, e, r);
    } catch {
    }
  if ("get" in r || "set" in r)
    throw new R("Accessors not supported");
  return "value" in r && (o[e] = r.value), o;
};
export {
  c as default
};
